import './number';
import './object';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/polyfills/index.js